import Command from "@ckeditor/ckeditor5-core/src/command";
import randomUUIDGenerator from "../../src/utils/randomUUIDGenerator.js";
import { CkeditorConstants } from "../../src/utils";

const { 
  WK_DISABLE_USER_SELECTION,
  helperAttributes: { DATA_UNLOCK, CONTENTEDITABLE },
  unLockValues: { no_one },
  htmlAttributes: { CLASS }, HEADINGS, HEADING_TAG_NAMES, class: { CK_TOOLTIP }, event: { MOUSEUP } } = CkeditorConstants;
export default class RestrictedHtmlEditingCommand extends Command {
  constructor(editor) {
    super(editor);
    this.dataSubtemplates = false;
    this.highlightHeadings = HEADING_TAG_NAMES;
    this.highlightHeadingsDomFormat = HEADINGS;
  }

  setDataAttr() {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    editor.model.change((writer) => {
      for (const item of range.getItems()) {
        if (item && item._attrs && item._attrs.get(CkeditorConstants.helperAttributes.SUBTEMPLATES_ALLOW)) {
          this.getAncestors(item)
        }
      }
    })
    this.dataSubtemplates = true;
  }

  getAncestors(item) {
    let subtemplateName = false;
    const viewEle = this.editor.editing.mapper.toViewElement(item);
    if (viewEle) {
      viewEle.getAncestors().find(el => {
        if (el && el.hasAttribute(CkeditorConstants.helperAttributes.SUBTEMPLATE_NAME)) {
          subtemplateName = true;
        }
      })
      if (!subtemplateName) {
        this.editor.model.change((writer) => {
          writer.setAttribute(CkeditorConstants.helperAttributes.DATA_TEMPLATE, "true", item);
        })
      }
    }
  }

  execute({ value, insertSubTemplate }) {
    const editor = this.editor;
    const docEditRoles = value;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    const restrictedItems = [];
    const dataUnlockElements = [];
    const defaultEditableElements = [];
    const dataUnlocknoOnEle = [];
    let isToolTipFeatureRequired = false;
    const spanTagsWithDataUnlockNoOne = [];

    if (!this.dataSubtemplates) {
      this.setDataAttr()
    }

    for (const item of range.getItems({ ignoreElementEnd: true })) {
      // eslint-disable-next-line max-len
      if (!isToolTipFeatureRequired && item.hasAttribute("data-usertooltip")) {
        isToolTipFeatureRequired = true;
      };
      
      if (
        item?.name === 'heading1' &&
        item?.parent?.name === 'header') {
        editor.model.change((writer) => {
          writer.setAttribute(CLASS, WK_DISABLE_USER_SELECTION, item);
          writer.setAttribute(DATA_UNLOCK, no_one, item);
        });
      }


      const editableSectionCheck =
        item.getAttribute("property") === "dcterms:title" ||
        item.getAttribute("class") === "section-content";
      if (item.getAttribute("data-unlock") && editableSectionCheck) {
        dataUnlockElements.push(item);
      } else if (!item.getAttribute("data-unlock") && editableSectionCheck) {
        defaultEditableElements.push(item);
      } else {
        restrictedItems.push(item);
      }

      if (
        item.hasAttribute("data-unlock") &&
        item.getAttribute("data-unlock") === "NO-ONE" &&
        item.childCount > 1 &&
        item.getChild(0).name !== "paragraph"
      ) {
        if (
          item.name === 'span' &&
          this.editor.editing.mapper.toViewElement(item).getAttribute('typeof') === 'pcicore:Fragment'
        ) {
          spanTagsWithDataUnlockNoOne.push(item);
          editor.model.change((writer) => {
            writer.setAttribute(CLASS, WK_DISABLE_USER_SELECTION, item.parent);
          });
        }

        dataUnlocknoOnEle.push(item);
      }
    }

    editor.model.change((writer) => {
      for (let i = 0; i < restrictedItems.length; i++) {
        if (
          !restrictedItems[i].getAttribute("class") === "ckeditor-wrapper" &&
          !restrictedItems[i].name === "header" &&
          !(
            restrictedItems[i].name === "div" &&
            restrictedItems[i]._attrs.size === 0
          )
        ) {
          writer.setAttribute(CONTENTEDITABLE, "false", restrictedItems[i]);
        }
      }

      for (let i = 0; i < dataUnlockElements.length; i++) {
        writer.setAttribute(CONTENTEDITABLE, "false", dataUnlockElements[i]);
        if (
          dataUnlockElements[i].hasAttribute("data-noone") &&
          dataUnlockElements[i].hasAttribute("data-subtemplates-allow")
        ) {
          for (const childItems of dataUnlockElements[i].getChildren()) {
            writer.setAttribute(CONTENTEDITABLE, "false", childItems);
          }
        }

        // Adds selectable p tag incase if ptag is not available for multiple nested divs
        if (
          dataUnlockElements[i].hasAttribute("data-unlock") &&
          dataUnlockElements[i].childCount === 0 &&
          dataUnlockElements[i].name === "div"
        ) {
          this.editor.model.change((writer) => {
            writer.appendElement("paragraph", dataUnlockElements[i]);
          });
        }

        if (
          dataUnlockElements[i].getAttribute("data-unlock") === "NO-ONE" &&
          !dataUnlockElements[i].hasAttribute("data-noone") &&
          dataUnlockElements[i].getAttribute("data-subtemplates-allow")
        ) {
          writer.setAttribute(
            "data-noone",
            randomUUIDGenerator(),
            dataUnlockElements[i]
          );
          for (const childItems of dataUnlockElements[i].getChildren()) {
            if (
              childItems.name === "div" &&
              !childItems.hasAttribute("data-subtemplates-allow") &&
              !childItems.hasAttribute("data-unlock")
            ) {
              writer.setAttribute(
                "data-noone",
                randomUUIDGenerator(),
                childItems
              );
              // Removal of empty p tags for saved data-noone placeholders
              for (const innerChild of childItems.getChildren()) {
                if (
                  childItems.childCount === 1 &&
                  innerChild.name === "paragraph" &&
                  innerChild.childCount === 0 &&
                  innerChild.isEmpty === true
                ) {
                  writer.remove(innerChild);
                }
              }
            }
            if (childItems.name === "paragraph") {
              writer.setAttribute("contenteditable", "false", childItems);
            }
          }
        }
      }

      for (let i = 0; i < defaultEditableElements.length; i++) {
        for (const childItems of defaultEditableElements[i].getChildren()) {
          if (
            childItems.name &&
            childItems.name !== 'section' &&
            childItems.name !== 'numberedcitation' &&
            childItems.name !== 'inlineimage' &&
            childItems.name !== 'inlineaudio'
          ) {
            editor.model.change((writer) => {
              writer.setAttribute('contenteditable', 'true', childItems);
            });
          }
        }
        writer.setAttribute(
          "contenteditable",
          "true",
          defaultEditableElements[i]
        );

        writer.removeAttribute("htmlAttributes", defaultEditableElements[i]);
      }

      for (let i = 0; i < dataUnlocknoOnEle.length; i++) {
        writer.setAttribute(
          "data-disablecursorparent",
          " ",
          dataUnlocknoOnEle[i]
        );
        writer.removeAttribute("contenteditable", dataUnlocknoOnEle[i]);
        for (const item of dataUnlocknoOnEle[i].getChildren()) {
          if (item.childCount > 0 && item.hasAttribute("class") && item.getAttribute("class") !== "ref") {
            writer.setAttribute("data-disablecursorparent", " ", item);
            if (
              item.hasAttribute("contenteditable") &&
              item.getAttribute("contenteditable") === "false"
            ) {
              writer.removeAttribute("contenteditable", item);
            }
          }
        }
      }
    });

    this.listenTo(this.editor.editing.view.document, "click", (event, data, isFocused) => {
      const chkForAssets = data.domTarget.hasAttribute('class') && data.domTarget.getAttribute('class').includes('media-class');
      if (data.domTarget.hasAttribute("contentEditable") &&
        data.domTarget.getAttribute("contentEditable") === 'false' &&
        !chkForAssets
      ) {
        editor.editing.view.domRoots.get("main").blur();
      }
    });

    this.listenTo(this.editor.editing.view.document, "blur", (event, data) => {
      editor.editing.view.document.isFocused = false;
    });

    dataUnlockElements.forEach((itemPendingAccessGrant) => {
      const dataUnlockAccessRoles = itemPendingAccessGrant
        .getAttribute("data-unlock")
        .split(",");
      editor.model.change((writer) => {
        if (itemPendingAccessGrant.getAttribute("data-unlock") === "ALL") {
          writer.setAttribute(
            "contenteditable",
            "true",
            itemPendingAccessGrant
          );
          const { SECTION, INLINE_AUDIO, INLINE_IMAGE } = CkeditorConstants.htmlElement;
          const { CLASS } = CkeditorConstants.htmlAttributes;
          for (const childItems of itemPendingAccessGrant.getChildren()) {
            if (childItems.name && childItems.name !== SECTION && childItems.name !== INLINE_AUDIO && childItems.name !== INLINE_IMAGE && !(childItems.hasAttribute(CLASS) && childItems.getAttribute(CLASS).includes(CkeditorConstants.class.REF))) {
              writer.setAttribute("contenteditable", "true", childItems);
            }
          }
        } else {
          dataUnlockAccessRoles.forEach((roles) => {
            if (docEditRoles.includes(roles)) {
              writer.setAttribute(
                "contenteditable",
                "true",
                itemPendingAccessGrant
              );
              for (const childItems of itemPendingAccessGrant.getChildren()) {
                if (
                  childItems.name &&
                  childItems.name !== 'section' &&
                  childItems.name !== 'numberedcitation' &&
                  childItems.name !== 'inlineimage' &&
                  childItems.name !== 'inlineaudio'
                ) {
                  writer.setAttribute('contenteditable', 'true', childItems);
                }
              }
            } else {
              for (const childItems of itemPendingAccessGrant.getChildren()) {
                if (childItems.name && childItems.name !== "section") {
                  writer.setAttribute("contenteditable", "false", childItems);
                }

                const { DATA_UNLOCK, CONTENTEDITABLE } = CkeditorConstants.helperAttributes;
                const chkAttributeElement = childItems._attrs.get(DATA_UNLOCK);
                const { name } = childItems.childCount === 1 && childItems.getChild(0);
                if (
                  chkAttributeElement && name &&
                  chkAttributeElement === CkeditorConstants.unLockValues.no_one &&
                  name !== CkeditorConstants.htmlElement.PARAGRAPH &&
                  name !== CkeditorConstants.htmlElement.SPAN &&
                  childItems.hasAttribute(CONTENTEDITABLE)
                ) {
                  writer.removeAttribute(CONTENTEDITABLE, childItems)
                }

                if (
                  childItems.name === "div" &&
                  childItems.hasAttribute("data-unlock") &&
                  childItems.childCount > 1
                ) {
                  writer.setAttribute("contenteditable", "true", childItems);
                }
              }
            }
          });
        }
        for (let i = 0; i < defaultEditableElements.length; i++) {
          for (let ele of defaultEditableElements[i].getAncestors()) {
            for (let key of ele.getAttributes()) {
              if (key[0] === "data-noone") {
                const range = editor.model.createRangeIn(ele);
                for (const value of range.getWalker()) {
                  if (!value.item.hasAttribute("data-unlock")) {
                    if (
                      (value.item.name === "div" &&
                        value.item.childCount > 1 &&
                        value.item.hasAttribute("contenteditable") &&
                        !value.item.hasAttribute("data-noone")) ||
                      value.item.name === "header"
                    ) {
                      writer.setAttribute(
                        "contenteditable",
                        "true",
                        value.item
                      );
                    } else if (
                      (value.item.parent &&
                        value.item.parent.hasAttribute("data-unlock") &&
                        value.item.parent.getAttribute("data-unlock") !==
                        "ALL") ||
                      (value.item.parent &&
                        value.item.parent.hasAttribute("contenteditable") &&
                        value.item.parent.getAttribute("contenteditable") ===
                        "false")
                    ) {
                      writer.setAttribute(
                        "contenteditable",
                        "false",
                        value.item
                      );
                    }
                  }
                }
              }
            }
          }
        }
      });
    });

    const dataCursorParent = [];
    for (const item of range.getItems({ ignoreElementEnd: true })) {
      if (item.hasAttribute("data-disablecursorparent")) {
        dataCursorParent.push(item);
      }
    }
    this.editor.model.change((writer) => {
      dataCursorParent.forEach((item) => {
        if (
          item.hasAttribute("data-unlock") &&
          item.getAttribute("data-unlock") === "NO-ONE" &&
          item.childCount === 1 &&
          item.getChild(0).name === "paragraph"
        ) {
          writer.setAttribute("contenteditable", "false", item);
        } else if (
          item.hasAttribute("data-unlock") &&
          item.getAttribute("data-unlock") === "ALL" &&
          item.hasAttribute("contenteditable") &&
          item.getAttribute("contenteditable") === "false"
        ) {
          writer.setAttribute("contenteditable", "true", item);
        } else if (
          !item.hasAttribute("data-unlock") &&
          item.hasAttribute("contenteditable") &&
          item.getAttribute("contenteditable") === "false"
        ) {
          writer.setAttribute("contenteditable", "true", item);
        }
      });
    });

    // Call tooltip feature functions if data-usertooltip is in html
    if (isToolTipFeatureRequired) {
      this.createTemplateToolTip();
    }
    if (!insertSubTemplate) {
      this.editor.commands.get('undo').forceDisabled();
      this.editor.commands.get('undo')._stack = [];
    }
    this.customSetSelectionOnClick();

    [...spanTagsWithDataUnlockNoOne].forEach((item) => {
      editor.model.change((writer) => {
        writer.setAttribute(CONTENTEDITABLE, 'false', item.parent);
        writer.setAttribute(DATA_UNLOCK, no_one, item.parent);
      });
    });
  }

  createTemplateToolTip() {
    const validItemArr = [];
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    editor.model.change((writer) => {
      for (const item of range.getItems({ ignoreElementEnd: true })) {
        const validItemCheck =
          ((item.hasAttribute("property") &&
            item.getAttribute("property") === "dcterms:title") ||
            (item.hasAttribute("class") &&
              item.getAttribute("class").includes("section-content"))) &&
          (item.hasAttribute("data-unlock") ||
            item.hasAttribute("data-subtemplates-allow")) &&
          item.hasAttribute("data-usertooltip");
        if (validItemCheck) {
          validItemArr.push(item);
        }
      }
      for (let i = 0; i < validItemArr.length; i++) {
        if (
          validItemArr[i].hasAttribute("data-unlock") &&
          validItemArr[i].getAttribute("data-unlock") !== "NO-ONE" &&
          validItemArr[i].getAttribute("data-unlock") !== "ALL" &&
          validItemArr[i].hasAttribute("contenteditable")
        ) {
          if (validItemArr[i].getAttribute("contenteditable") === "true") {
            this.setTitleAttribute(writer, "data-usertooltip", validItemArr[i]);
          } else if (
            validItemArr[i].getAttribute("contenteditable") === "false"
          ) {
            this.setTitleAttribute(
              writer,
              "data-usertooltip-restricted",
              validItemArr[i]
            );
          }
        } else {
          this.setTitleAttribute(writer, "data-usertooltip", validItemArr[i]);
        }
      }
      this.toolTipHandler();
    });
  }

  setTitleAttribute(writer, attributeName, item) {
    const toolTipTitle = item.getAttribute(attributeName);
    if (this.highlightHeadingsDomFormat.includes(item.name)) {
      writer.setAttribute("data-cke-tooltip-text", toolTipTitle, item);
    }

    for (const children of item.getChildren()) {
      if (
        children.name === "section" ||
        (children.name === "div" && children.hasAttribute("typeof"))
      ) {
        writer.setAttribute("data-tooltipnonemptysection", " ", item);
        writer.removeAttribute("data-cke-tooltip-text", item);
      }
      if (
        children.name === "paragraph" ||
        (children.name === "div" && !children.hasAttribute("typeof"))
      ) {
        writer.setAttribute("data-cke-tooltip-text", toolTipTitle, children);
      }
    }
  }

  toolTipHandler() {
    // Tooltip Feature start
    // Checks if current hovered div has data-currentfocused-element is already clicked
    this.listenTo(
      this.editor.editing.view.document,
      "mousemove",
      (evt, domEventData) => {
        if (
          domEventData.domTarget.attributes.getNamedItem(
            "data-cke-tooltip-text"
          )
        ) {
          if (
            localStorage.getItem("currentFocusedId") &&
            document.querySelector(`.${CK_TOOLTIP}`) &&
            domEventData.domTarget.attributes.getNamedItem(
              "data-currentfocused-element"
            ) &&
            domEventData.domTarget.attributes.getNamedItem(
              "data-currentfocused-element"
            ).value === localStorage.getItem("currentFocusedId")
          ) {
            document
              .querySelector(`.${CK_TOOLTIP}`)
              .setAttribute("id", "hideToolTip");
          } else {
            const isHeader = this.highlightHeadings.includes(
              domEventData.domTarget.nodeName
            );
            this.showToolTip(isHeader);
          }
        }
      }
    );

    // Created data-currentfocused-element and sets localStorage on clicked element
    this.listenTo(
      this.editor.editing.view.document,
      "click",
      (evt, domEventData) => {
        let clickedElement = this.editor.model.document.selection.getFirstPosition()
          .parent;
        if (
          domEventData.domTarget.attributes.getNamedItem("contenteditable") &&
          (domEventData.domTarget.parentElement.attributes.getNamedItem(
            "data-unlock"
          ) ||
            (!domEventData.domTarget.parentElement.attributes.getNamedItem(
              "data-unlock"
            ) &&
              domEventData.domTarget.attributes.getNamedItem("data-unlock"))) &&
          domEventData.domTarget.attributes.getNamedItem("contenteditable")
            .value === "false"
        ) {
          this.showToolTip();
          const range = this.editor.model.createRangeIn(
            this.editor.model.document.getRoot()
          );
          const currentfocusedEle = [];
          for (const item of range.getItems({ ignoreElementEnd: true })) {
            if (
              localStorage.getItem("currentFocusedId") &&
              item.hasAttribute("data-currentfocused-element") &&
              item.getAttribute("data-currentfocused-element") ===
              localStorage.getItem("currentFocusedId")
            ) {
              currentfocusedEle.push(item);
            }
          }
          for (let i = 0; i < currentfocusedEle.length; i++) {
            this.editor.model.enqueueChange({ isUndoable: false }, writer => {
              writer.removeAttribute(
                "data-currentfocused-element",
                currentfocusedEle[i]
              );
              clickedElement = null;
            });
          }
        }

        if (clickedElement) {
          if (
            clickedElement &&
            clickedElement._attrs.has("contenteditable") &&
            clickedElement._attrs.get("contenteditable") !== "false"
          ) {
            if (document.querySelector(`.${CK_TOOLTIP}`)) {
              document
                .querySelector(`.${CK_TOOLTIP}`)
                .setAttribute("id", "hideToolTip");
            }
            let currentFocusedId = randomUUIDGenerator();
            this.editor.model.enqueueChange({ isUndoable: false }, writer => {
              writer.setAttribute(
                "data-currentfocused-element",
                currentFocusedId,
                clickedElement
              );
            });

            localStorage.setItem("currentFocusedId", currentFocusedId);
          }
        }
      }
    );

    // Resets tooltip when user clicks apart from document
    document.body.addEventListener(
      "click",
      (evt) => {
        if (
          document.querySelector(".istemplatedoc") &&
          !document.querySelector(".istemplatedoc").contains(evt.target)
        ) {
          localStorage.removeItem("currentFocusedId");
          const range = this.editor.model.createRangeIn(
            this.editor.model.document.getRoot()
          );
          const currentfocusedEle = [];
          for (const item of range.getItems({ ignoreElementEnd: true })) {
            if (
              localStorage.getItem("currentFocusedId") &&
              item.hasAttribute("data-currentfocused-element") &&
              item.getAttribute("data-currentfocused-element") ===
              localStorage.getItem("currentFocusedId")
            ) {
              currentfocusedEle.push(item);
            }
          }
          for (let i = 0; i < currentfocusedEle.length; i++) {
            this.editor.model.change((writer) => {
              writer.removeAttribute(
                "data-currentfocused-element",
                currentfocusedEle[i]
              );
              clickedElement = null;
            });
          }
          this.showToolTip();
        }
      },
      true
    );
    // Tooltip feature end
  }

  showToolTip(isHeader) {
    if (document.querySelector(`.${CK_TOOLTIP}`)) {
      document.querySelector(`.${CK_TOOLTIP}`).setAttribute("id", "showToolTip");
      document.querySelector(`.${CK_TOOLTIP}`).style.marginTop = isHeader
        ? "6px"
        : "0px";
    }
  }
  /**
   * Sets a editor selection focus one character backward because focus in next element start.
   * Once detect a triple-click/mouse select line, moving the selection backward by one character.
   * A triple-click will select the entire line, i.e. all words that are in the line, as well as the trailing new line character that is at the very end of each line that is followed by more content.
   */
  customSetSelectionOnClick() {
    document.body.addEventListener(MOUSEUP, () => {
      const model = this.editor.model; const selection = model.document.selection;
      const { anchor, focus } = selection;
      if (selection.containsEntireContent(anchor.parent) &&
        anchor?.parent !== focus?.parent &&
        focus.isAtStart) {
        model.modifySelection(selection, {
          direction: "backward",
          unit: "character",
        });
      }
    });
  }
}
